import { ModuleWithProviders, NgModule } from '@angular/core';
import { OfbizFormsComponent } from './ofbiz-forms.component';
import { OfbizFormsService } from './ofbiz-forms.service';
import { LookupFieldComponent } from './ofbiz-lookup-field/lookup-field.component';
import { OfbizFormFieldComponent } from './ofbiz-form-field.component';
import {
  NbActionsModule,
  NbAutocompleteModule,
  NbButtonModule,
  NbCardModule,
  NbCheckboxModule,
  NbDatepickerModule,
  NbDialogModule,
  NbFormFieldModule,
  NbIconModule,
  NbInputModule,
  NbLayoutModule,
  NbListModule,
  NbMenuModule, NbSelectModule, NbSidebarModule, NbSpinnerModule, NbTimepickerModule, NbWindowModule
} from '@nebular/theme';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OfbizListComponent } from './ofbiz-list/ofbiz-list.component';
import { OfbizFindResultsComponent } from './ofbiz-find-results.component';
import { OfbizEditDialogComponent } from './ofbiz-edit-dialog.component';
import { OfbizDeleteDialogComponent } from './ofbiz-delete-dialog.component';
import { OfbizAddDialogComponent } from './ofbiz-add-dialog.component';
import { OfbizForm, OfbizList } from './ofbiz-form-model';
import { OfbizSummaryWindowComponent } from './ofbiz-summary-window/ofbiz-summary-window.component';
import { OfbizSummaryListComponent } from './ofbiz-summary-window/ofbiz-summary-list/ofbiz-summary-list.component';
import { OfbizSummaryFormComponent } from './ofbiz-summary-window/ofbiz-summary-form/ofbiz-summary-form.component';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { OfbizViewFormComponent } from './ofbiz-view-form/ofbiz-view-form.component';
import { OfbizViewListComponent } from './ofbiz-view-list/ofbiz-view-list.component';
import { SmartTableDatePickerComponent } from './smart-table-date-picker/smart-table-date-picker.component';
import { OfbizDatePickerComponent } from './ofbiz-date-picker/ofbiz-date-picker.component';
import { OfbizCellHyperLinkComponent } from './ofbiz-cell-hyper-link/ofbiz-cell-hyper-link.component';
import { OfbizCellDisplayComponent } from './ofbiz-cell-display/ofbiz-cell-display.component';
import { OfbizCellDisplayLinkComponent } from './ofbiz-cell-display-link/ofbiz-cell-display-link.component';
import { OfbizCustomLinkEditorComponent } from './ofbiz-custom-link-editor/ofbiz-custom-link-editor.component';
import { LookupFieldService } from './ofbiz-lookup-field/lookup-field.service';
import { OfbizFormListTitleComponent } from './ofbiz-form-list-title/ofbiz-form-list-title.component';
import { OfbizCellLinkedListComponent } from './ofbiz-cell-linked-list/ofbiz-cell-linked-list.component';
import { OfbizCellInternalLinkComponent } from './ofbiz-cell-internal-link/ofbiz-cell-internal-link.component';
import { OfbizCellDropdownComponent } from './ofbiz-cell-dropdown/ofbiz-cell-dropdown.component';
import { OfbizCellDropdownEditorComponent } from './ofbiz-cell-dropdown-editor/ofbiz-cell-dropdown-editor.component';
import { OfbizFormGroupComponent } from './ofbiz-form-group/ofbiz-form-group.component';
import { OfbizCellCheckComponent } from './ofbiz-cell-check/ofbiz-cell-check.component';
import { OfbizCheckBoxEditorComponent } from './ofbiz-check-box-editor/ofbiz-check-box-editor.component';
import { OfbizMultiSelectedCellComponent } from './ofbiz-multi-selected-cell/ofbiz-multi-selected-cell.component';
import { EnableDisableMultiSelectSubmitButtonDirective } from './enable-disable-multi-select-submit-button.directive';
import { OfbizMultiSubmitBtnComponent } from './ofbiz-multi-submit-btn/ofbiz-multi-submit-btn.component';
import { PaginationComponent } from './ofbiz-list/pagination/pagination.component';
import { CardModeComponent } from './ofbiz-list/card-mode/card-mode.component';
import { ItemFieldComponent } from './ofbiz-list/card-mode/item-field/item-field.component';
import { FieldValidationFlagDirective } from './directives/field-validation-flag.directive';
import { Angular2SmartTableModule } from 'angular2-smart-table';
import { OfbizCellImageComponent } from './ofbiz-cell-image/ofbiz-cell-image.component';
import { OfbizCellCheckboxComponent } from './ofbiz-cell-checkbox/ofbiz-cell-checkbox.component';
import { OfbizCellInputComponent } from './ofbiz-cell-input/ofbiz-cell-input.component';
import { OfbizCellSequenceComponent } from './ofbiz-cell-sequence/ofbiz-cell-sequence.component';
import { OfbizCellCompositeComponent } from './ofbiz-cell-composite/ofbiz-cell-composite.component';
import { CKEditorModule } from 'ng2-ckeditor';
import { OfbizFileFieldPreviewComponent } from './ofbiz-file-field-preview/ofbiz-file-field-preview.component';
import { FormUtilityService } from './form-utility.service';
import { OfbizTextqbeFieldComponent } from './ofbiz-textqbe-field/ofbiz-textqbe-field.component';
// import { confirmPasswordValidator } from './directives/password-validation.directive';

const ENTRY_COMPONENTS = [
  OfbizEditDialogComponent,
  OfbizDeleteDialogComponent,
  OfbizAddDialogComponent,
  SmartTableDatePickerComponent,
  OfbizCellHyperLinkComponent,
  OfbizCustomLinkEditorComponent,
  OfbizCellDropdownEditorComponent,
  OfbizCellLinkedListComponent
];
@NgModule({
  declarations: [
    OfbizFormsComponent,
    LookupFieldComponent,
    OfbizFormFieldComponent,
    OfbizListComponent,
    OfbizFindResultsComponent,
    OfbizEditDialogComponent,
    OfbizDeleteDialogComponent,
    OfbizAddDialogComponent,
    OfbizDeleteDialogComponent,
    OfbizSummaryWindowComponent,
    OfbizSummaryListComponent,
    OfbizSummaryFormComponent,
    SafeHtmlPipe,
    OfbizViewFormComponent,
    OfbizViewListComponent,
    SmartTableDatePickerComponent,
    OfbizDatePickerComponent,
    OfbizCellHyperLinkComponent,
    OfbizCellDisplayComponent,
    OfbizCellDisplayLinkComponent,
    OfbizCustomLinkEditorComponent,
    OfbizFormListTitleComponent,
    OfbizCellLinkedListComponent,
    OfbizCellInternalLinkComponent,
    OfbizCellDropdownComponent,
    OfbizCellDropdownEditorComponent,
    OfbizFormGroupComponent,
    OfbizCellCheckComponent,
    OfbizCheckBoxEditorComponent,
    OfbizMultiSelectedCellComponent,
    EnableDisableMultiSelectSubmitButtonDirective,
    OfbizMultiSubmitBtnComponent,
    PaginationComponent, CardModeComponent,
    ItemFieldComponent,
    FieldValidationFlagDirective,
    OfbizCellImageComponent,
    OfbizCellCheckboxComponent,
    OfbizCellInputComponent,
    OfbizCellSequenceComponent,
    OfbizCellCompositeComponent,
    OfbizFileFieldPreviewComponent,
    OfbizTextqbeFieldComponent],
  imports: [CommonModule,
    CKEditorModule,
    NbAutocompleteModule,
    NbIconModule,
    NbActionsModule,
    NbSelectModule,
    NbInputModule,
    NbFormFieldModule,
    NbButtonModule,
    NbLayoutModule,
    NbListModule,
    NbCheckboxModule,
    ReactiveFormsModule,
    FormsModule,
    Angular2SmartTableModule,
    NbDialogModule.forChild(),
    NbWindowModule.forChild(),
    NbCardModule,
    NbLayoutModule,
    NbSidebarModule,
    NbSpinnerModule,
    NbMenuModule,
    NbDatepickerModule.forRoot(),
    NbTimepickerModule.forRoot()
  ],
  exports: [
    OfbizFormsComponent,
    LookupFieldComponent,
    OfbizTextqbeFieldComponent,
    OfbizFormFieldComponent,
    OfbizListComponent,
    OfbizFindResultsComponent,
    OfbizEditDialogComponent,
    SafeHtmlPipe,
    OfbizViewFormComponent,
    OfbizViewListComponent,
    SmartTableDatePickerComponent,
    OfbizSummaryWindowComponent,
    OfbizFormListTitleComponent,
    OfbizCellDropdownComponent,
    OfbizCellDropdownEditorComponent,
    OfbizFormGroupComponent,
    OfbizCellHyperLinkComponent,
    OfbizCellLinkedListComponent]
})

export class OfbizFormsModule {
  public static forRoot(baseUrl: string): ModuleWithProviders<OfbizFormsModule> {
    return {
      ngModule: OfbizFormsModule,
      providers: [
        OfbizFormsService,
        {
          provide: 'baseUrl', // you can also use InjectionToken
          useValue: baseUrl
        },
        LookupFieldService, {
          provide: 'baseUrl', // you can also use InjectionToken
          useValue: baseUrl
        },
        FormUtilityService
      ],

    };
  }
}
